<template>
  <div id="map" ref="map" :class="mapClass"></div>
</template>

<script>
import { setupGooglePlaces } from '@/utils/googleSettingsConstants'
import { isEqual } from 'lodash-es'
var directionsService
var directionsRenderer
export default {
  name: 'GoogleMaps',
  props: {
    id: {
      type: [String, Number]
    },
    waypoints: {
      type: [Array, Object],
      required: true
    },
    multiple: {
      type: Boolean,
      default: false
    },
    mapClass: {
      type: String
    }
  },
  data () {
    return {
      map: null
    }
  },
  computed: {
    origin () {
      if (this.waypoints.length) {
        return this.waypoints.find(el => el.position === 'ORIGIN') || this.waypoints[0]
      } else {
        return this.waypoints.position === 'ORIGIN' ? this.waypoints : false
      }
    },
    destination () {
      if (this.waypoints.length) {
        return this.waypoints.find(el => el.position === 'DESTINATION') || this.waypoints[ this.waypoints.length - 1 ]
      } else {
        return this.waypoints.position === 'DESTINATION' ? this.waypoints : false
      }
    }
  },
  methods: {
    initializeMap () {
      /* eslint-disable no-undef */
      directionsService = new google.maps.DirectionsService()
      directionsRenderer = new google.maps.DirectionsRenderer()
      this.map = new google.maps.Map(this.$refs.map, {
        center: new google.maps.LatLng(40, -3.7),
        zoom: 5
      })
      /* eslint-enable no-undef */
      directionsRenderer.setMap(this.map)
      this.generateRoute()
    },
    generateRoute () {
      if (!this.origin && !this.destination) return
      /* eslint-disable no-undef */
      const originPoint = new google.maps.LatLng(Number(this.origin.lat), Number(this.origin.lng))
      const destinationPoint = new google.maps.LatLng(Number(this.destination.lat), Number(this.destination.lng))
      let routeWaypoints = []
      if (this.waypoints.length > 0) {
        const intermediatePoints = this.waypoints.slice(1, -1)
        intermediatePoints.forEach(el => {
            let location = new google.maps.LatLng(Number(el.lat), Number(el.lng))
            routeWaypoints.push({ location: location })
        })

        // this.waypoints.forEach((el) => {
        //   if (!['ORIGIN', 'DESTINATION'].includes(el.position)) {
        //     let location = new google.maps.LatLng(Number(el.lat), Number(el.lng))
        //     routeWaypoints.push({ location: location })
        //   }
        // })
      }
      var request = {
        origin: originPoint,
        destination: destinationPoint,
        waypoints: routeWaypoints,
        travelMode: 'DRIVING' }

      directionsService.route(request, function (result, status) {
        if (status === 'OK') {
          directionsRenderer.setDirections(result)
        }
      })
      /* eslint-enable no-undef */
    }
  },
  async mounted () {
    await setupGooglePlaces()
    this.initializeMap()
  },
  watch: {
    waypoints: function (newV, oldV) {
      if (!isEqual(newV, oldV)) {
        this.generateRoute()
      }
    }
  }
}
</script>

<style>
#map {
  width: 100%;
  height:100%;
}

</style>
